import { THERAPIST_JOB_TITLES_ENUMS, TherapistJobTitle } from '@pflegia/types/api/job-title/data/definition';
import { RequiredJobTitle } from '@pflegia/types/api/job-title/multiposting/types';

export const isTherapistJobTitle = ({ title }: RequiredJobTitle): boolean =>
  THERAPIST_JOB_TITLES_ENUMS.includes(title as TherapistJobTitle);
